import { render, staticRenderFns } from "./PhotosManager.vue?vue&type=template&id=64a9ccc8&scoped=true"
import script from "./PhotosManager.vue?vue&type=script&lang=js"
export * from "./PhotosManager.vue?vue&type=script&lang=js"
import style0 from "./PhotosManager.vue?vue&type=style&index=0&id=64a9ccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9ccc8",
  null
  
)

export default component.exports